import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PasswordProfileType } from "../types/PasswordProfileType";
import { apiClient } from "src/utils/Api/apiClient";

interface passwordProfileState {
	passwordProfiles: Array<PasswordProfileType>;
	passwordProfileLoading: boolean;
	passwordProfileError: string | null;
}

const initialState: passwordProfileState = {
	passwordProfiles: [],
	passwordProfileLoading: false,
	passwordProfileError: null
}

export const getPasswordProfiles = createAsyncThunk(
	'user/getpasswordProfiles',
	async (passwordProfileData: any, { rejectWithValue }) => {
		try {
			const response = await apiClient.get('user/getpasswordProfiles', passwordProfileData);
			return response.data;
		} catch (passwordProfileError: any) {
			return rejectWithValue(passwordProfileError.message || 'An error occured');
		}
	}
);

const passwordProfileSlice = createSlice({
	name: 'passwordProfile',
	initialState,
	reducers: {
		reset: () => initialState,
	},
	extraReducers: (builder) => {
		//get all passwordProfiles from server
		builder.addCase(getPasswordProfiles.pending, (state) => {
			state.passwordProfileLoading = true;
			state.passwordProfileError = null;
		});
		builder.addCase(getPasswordProfiles.fulfilled, (state, action) => {
			state.passwordProfileLoading = false;
			state.passwordProfiles = action.payload;
		});
		builder.addCase(getPasswordProfiles.rejected, (state, action) => {
			state.passwordProfileLoading = false;
			state.passwordProfileError = action.payload as string;
		});

	}
});

export const { reset } = passwordProfileSlice.actions;
export default passwordProfileSlice.reducer;
